import { Flex } from "@mantine/core";

import { useClikNegativeEvents } from "../../../../api/hooks/clikResult/useClikNegativeEvent.ts";
import AccordionMultifieldsCards from "../../../../components/AccordionMultifieldCards/AccordionMultifieldCards.tsx";
import NoDataMessage from "../../../../components/NoDataMessage/NoDataMessage.tsx";
import SectionTitle from "../../../../components/Section/SectionTitle/SectionTitle.tsx";
import { useCRNegativeEventCardInfo } from "./hooks/useCRNegativeEventCardInfo.tsx";

interface ClikResultNegativeEventProps {
  clikResultId: number;
}

const ClikResultNegativeEvent = ({
  clikResultId,
}: ClikResultNegativeEventProps) => {
  const [{ data, fetching }] = useClikNegativeEvents({ clikResultId });

  const negativeEventsInfo = useCRNegativeEventCardInfo({
    data: data?.clikNegativeEvents,
  });

  if (!fetching && !negativeEventsInfo?.length) {
    return (
      <Flex direction="column" gap={16}>
        <SectionTitle variant="golden">Negative Events</SectionTitle>
        <NoDataMessage />
      </Flex>
    );
  }

  return (
    <Flex direction="column" gap={16}>
      <SectionTitle variant="golden">Negative Events</SectionTitle>
      <AccordionMultifieldsCards
        cardItems={negativeEventsInfo}
        loading={fetching}
      />
    </Flex>
  );
};

export default ClikResultNegativeEvent;
